import { PROD_CATEG_1 } from "@saleor/utils/constants";

import { IListLine } from "./views/ViewEditOrder";

export const getAddressValue = addresses =>
  `${addresses?.displayText} - ${addresses?.addressText}`;

export const splitItemNo = itemNo => {
  const [first, second] = itemNo.split(".");
  if (first && second === "001") {
    return {
      isSplit: false,
      first,
      second
    };
  }
  return {
    isSplit: true,
    first,
    second
  };
};

const calculateNetPrice = (
  quantity,
  pricePerUnit,
  saleQtyFactor,
  materialGroup1,
  prcGroup1
) => {
  if (PROD_CATEG_1(materialGroup1) || PROD_CATEG_1(prcGroup1)) {
    return roundDecimalToTwoPlace(
      Number(quantity) * Number(pricePerUnit) * (Number(saleQtyFactor) / 1000)
    );
  } else {
    return getNetPriceForProductGroup2(Number(quantity), Number(pricePerUnit));
  }
};

export const getTotalNetPriceByLine = orderLine =>
  calculateNetPrice(
    orderLine.itemQty,
    orderLine.pricePerUnit,
    orderLine.saleQtyFactor,
    orderLine.materialGroup1,
    orderLine.prcGroup1
  );

export const showIplanButtonCheck = data =>
  data.some(item => PROD_CATEG_1(item.materialGroup1));

export const getTotalNetPriceByLineNewProductGroup = orderLine =>
  Number(orderLine.orderQty) * Number(orderLine.netPrice);

export const roundDecimalToTwoPlace = qty =>
  Math.round((qty + Number.EPSILON) * 100) / 100;

export const getNetPriceForProductGroup1 = (quantity, pricePerUnit, weight) =>
  roundDecimalToTwoPlace(
    Number(quantity) * Number(pricePerUnit) * Number(weight)
  );

export const getNetPriceForProductGroup2 = (quantity, pricePerUnit) =>
  roundDecimalToTwoPlace(Number(quantity) * Number(pricePerUnit));

export const checkHasPriceAffectingChanges = (
  listLineOrder: IListLine[] = [],
  listLineOrderInitial: IListLine[] = []
) => {
  const hasAddOrRemoveItems =
    listLineOrder.length !== listLineOrderInitial.length;
  if (hasAddOrRemoveItems) {
    return true;
  }

  const hasValuesChanged = listLineOrder.some((line, index) => {
    const initial = listLineOrderInitial[index];
    return line.quantity !== initial.quantity;
  });

  if (hasValuesChanged) {
    return true;
  }

  return false;
};
